<script lang="ts" setup>
const model = defineModel<number>('page')
const cursor = defineModel<string | undefined>('cursor')

withDefaults(defineProps<{
  meta?: PaginationCursor | PaginationDefault
  withoutNumbers?: boolean
}>(), {
  withoutNumbers: false,
})

function isDefault(meta: PaginationCursor | PaginationDefault): meta is PaginationDefault {
  return (meta as PaginationDefault).total !== undefined
}
</script>

<template>
  <div
    v-if="meta && !isDefault(meta)"
    class="w-full flex justify-center py-4 max-w-full overflow-auto"
  >
    <div
      class="flex items-center gap-1"
    >
      <UiButton
        v-if="meta.prev_cursor"
        variant="ghost"
        @click="cursor = undefined"
      >
        <Icon name="tabler:chevrons-left" />
        {{ $t('Back to start') }}
      </UiButton>
      <UiButton
        v-if="meta.prev_cursor"
        variant="ghost"
        @click="cursor = meta.prev_cursor"
      >
        <Icon name="tabler:chevron-left" />
        {{ $t('Previous') }}
      </UiButton>

      <UiButton
        v-if="meta.next_cursor"
        variant="ghost"
        @click="cursor = meta.next_cursor"
      >
        {{ $t('Next') }}
        <Icon
          name="tabler:chevron-right"
          class="size-4"
        />
      </UiButton>
    </div>
  </div>
  <div
    v-else-if="meta && isDefault(meta) && meta.total > meta.per_page"
    class="w-full flex justify-center py-4 max-w-full overflow-auto"
  >
    <UiPagination
      v-model:page="model"
      :total="meta.total"
      :sibling-count="1"
      :items-per-page="meta.per_page"
    >
      <UiPaginationList
        v-slot="{ items }"
        class="flex items-center gap-1"
      >
        <UiPaginationFirst />
        <UiPaginationPrev />

        <template v-if="!withoutNumbers">
          <template v-for="(item, index) in items">
            <UiPaginationListItem
              v-if="item.type === 'page'"
              :key="index"
              :value="item.value"
              as-child
            >
              <UiButton
                class="w-10 h-10 p-0"
                :variant="item.value === model ? 'default' : 'outline'"
              >
                {{ item.value }}
              </UiButton>
            </UiPaginationListItem>
            <UiPaginationEllipsis
              v-else
              :key="item.type"
              :index="index"
            />
          </template>
        </template>

        <UiPaginationNext />
        <UiPaginationLast />
      </UiPaginationList>
    </UiPagination>
  </div>
</template>
